module['exports'] = [
  'سرخ',
  'ہرا',
  'نیلا',
  'پیلا',
  'ہلکا ہرا',
  'سفہد',
  'کالا',
  'نارنجی',
  'پیکا',
  'مہندی',
  'آسمانی',
  'سنہری',
  'چاندنی',
];
